import React from "react";

import HeaderBackButton from "./HeaderBackbutton";

import { HomeContainer } from "../styled-components/homestyle"

import { techprojects } from "../TechprojectData";

import { 
  Gallery, 
  ProjectWrapper, 
  ProjectOverlay,
  ProjectImage, 
  TechProjectLink } from "../styled-components/projectListstyle";

const TechprojectList = () => {

  return (
    <HomeContainer>
      <HeaderBackButton />
        <Gallery>
            {techprojects.map((item, index) => (
              <ProjectWrapper key={index}>
                <ProjectImage 
                  src={item.image}
                  alt={item.title} />
              <ProjectOverlay>
              <TechProjectLink 
                href={item.link}
                rel="noopener noreferrer" 
                target="_blank" 
                title={`Link to ${item.title}`}>
                {item.info.map((line, index) => (
                  <React.Fragment key={index}>{line}<br /></React.Fragment>
                ))}
              </TechProjectLink>
            </ProjectOverlay>
            </ProjectWrapper>
              ))}
          </Gallery>
      </HomeContainer>
  )
}

export default TechprojectList;